import axios from 'axios';

const PAYRO_API = process.env.REACT_APP_PAYRO_API_URL || 'https://api.payro.io';

export const authApi = {
  sendPhone: (phoneNumber: string) =>
    axios.post(`${PAYRO_API}/auth/admin`, { phoneNumber }),

  verifyOtp: (otp: string, sessionToken: string) =>
    axios.post(`${PAYRO_API}/auth/otp`, { otp, sessionToken }),

  getUserInfo: (accessToken: string) =>
    axios.get(`${PAYRO_API}/user`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
};
